import * as applyTemplateResources from './applyTemplate/resource';
import * as defaultTemplateResources from './defaultTemplate/resource';
import { templateResource } from './templateResource';
export default {
  templateResource,
  ...applyTemplateResources,
  ...defaultTemplateResources
};